import {Component, OnChanges, OnInit, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {MenuService} from "./menu.service";

export class MenuItem {
	public submenu: any = [];
	constructor(
		public title: string,
		public url: string
	) {};
}

@Component({
    providers: [MenuService],
    selector: 'app-menu',
    styleUrls: ['./menu.styles.css'],
    templateUrl: './menu.template.html'
})

export class MenuComponent implements OnInit, OnChanges {

	public regExternalLink = /^(https?:)?\/\//;
    public tree: any;
	public menu: any;
	@Input() isLogging: boolean;
	@Output() menuLoaded = new EventEmitter<{isMenuLoaded: boolean}>();

    constructor(
        private service: MenuService
    )
    {}

    ngOnInit() {}
	
	loadMenu() {
		this.onLoadedMenu(false);
		this.service.getTree().subscribe(
			data => {
                this.tree = data; 
                let menu = [];

                for (let item of this.tree) {
                    let itemMemu = new MenuItem(item.title, item.url);
                    if (item.items) {
                        for (let subitem of item.items) {
                            let itemSubMemu = new MenuItem(subitem.title, subitem.url);
                            if (subitem.items) {
                                for (let subitem2 of subitem.items) {
                                    let itemSubMemu2 = new MenuItem(subitem2.title, subitem2.url);
                                    itemSubMemu.submenu.push(itemSubMemu2);
                                }
                            }
                            itemMemu.submenu.push(itemSubMemu);
                        }
                    }
                    menu.push(itemMemu);
                }
                this.menu = menu;
                this.onLoadedMenu(true);
			},
			error => {
                this.menu = [];
                this.tree = [];
                this.onLoadedMenu(true);
                console.log(error.message);
			});	
	}

	onLoadedMenu(val: boolean) {
		this.menuLoaded.emit({isMenuLoaded: val});
	}
	
	ngOnChanges (isLogging: SimpleChanges) {
		this.loadMenu();
	}
}


// WEBPACK FOOTER //
// ./src/app/layouts/menu/menu.component.ts